import DynamicForm from "./DynamicForm.jsx";

/**
 * Second-step form after choosing an OIN catalog row: maps curated UI schema fields to DynamicForm.
 */
export default function OINConfigureForm({
  ui,
  disabled = false,
  submitting = false,
  onFieldChange,
  onSubmit,
  onCancel,
}) {
  if (!ui || ui.status !== "ready") return null;

  const title =
    ui.app?.displayName != null && String(ui.app.displayName).trim()
      ? String(ui.app.displayName).trim()
      : ui.app?.name != null
        ? String(ui.app.name)
        : "Application";

  return (
    <div className="mt-4 space-y-3 rounded-xl border border-amber-400/25 bg-amber-500/[0.06] px-4 py-3">
      <p className="text-[10px] font-semibold uppercase tracking-widest text-amber-200/90">Configure app</p>
      <p className="text-sm font-semibold text-slate-100">{title}</p>
      {ui.note ? (
        <p className="rounded-lg border border-amber-400/20 bg-black/20 px-3 py-2 text-[12px] text-amber-100/95">{ui.note}</p>
      ) : null}
      <DynamicForm
        fields={ui.formFields}
        values={ui.values}
        onChange={onFieldChange}
        disabled={disabled || submitting}
        onSubmit={onSubmit}
        onPrimaryAction={onSubmit}
        primaryActionLabel="Create in Okta"
        primaryBusy={submitting}
        primaryDisabled={submitting}
        onNavigateBack={onCancel}
        navigateBackDisabled={submitting}
      />
    </div>
  );
}
